import React from 'react'
import { Table, Space, Button, Tooltip, theme } from 'antd'
import { CheckOutlined, EditOutlined } from '@ant-design/icons'
import { formatPatientInfo, formatDueDate, getPriorityTag, formatDateTime } from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const TaskTable = ({ data, isCompleted = false, onCompleteTask }) => {
  const { token } = theme.useToken()

  const getColumns = () => {
    const columns = [
      {
        title: 'Task ID',
        dataIndex: 'taskId',
        key: 'taskId',
        width: 100
      },
      {
        title: 'Patient',
        dataIndex: 'patientName',
        key: 'patientName',
        render: (text, record) => formatPatientInfo(text, record.patientId)
      },
      {
        title: 'Task Description',
        dataIndex: 'taskDescription',
        key: 'taskDescription'
      },
      {
        title: 'Assigned To',
        dataIndex: 'assignedToStaffName',
        key: 'assignedToStaffName'
      },
      {
        title: 'Category',
        dataIndex: 'category',
        key: 'category'
      },
      {
        title: 'Priority',
        dataIndex: 'priority',
        key: 'priority',
        render: (priority) => getPriorityTag(priority)
      },
      {
        title: 'Due Date/Time',
        dataIndex: 'dueDate',
        key: 'dueDate',
        render: (date, record) => formatDueDate(date, isCompleted),
        sorter: (a, b) => new Date(a.dueDate) - new Date(b.dueDate)
      }
    ]

    // Add completed date column for completed tasks
    if (isCompleted) {
      columns.push({
        title: 'Completed At',
        dataIndex: 'completedAt',
        key: 'completedAt',
        render: (date) => formatDateTime(date)
      })
    }
    // Add actions column for pending tasks
    else {
      columns.push({
        title: 'Actions',
        key: 'actions',
        render: (_, record) => (
          <Space size='small'>
            <Tooltip title='Complete Task'>
              <Button
                icon={<CheckOutlined style={{ color: token.colorSuccess }} />}
                size='small'
                onClick={() => onCompleteTask(record)}
                style={{
                  background: hexToRGBA(token.colorSuccess, 0.1),
                  borderColor: token.colorSuccess
                }}
              />
            </Tooltip>
            <Tooltip title='Edit Task'>
              <Button
                icon={<EditOutlined style={{ color: token.colorPrimary }} />}
                size='small'
                style={{
                  background: hexToRGBA(token.colorPrimary, 0.1),
                  borderColor: token.colorPrimary
                }}
              />
            </Tooltip>
          </Space>
        )
      })
    }

    return columns
  }

  return <Table columns={getColumns()} dataSource={data} rowKey='taskId' pagination={{ pageSize: 10 }} />
}

export default TaskTable
